export const languages = {
  en: 'English',
  de: 'Deutsch',
  ru: 'Русский',
  es: 'Español',
  it: 'Italiano',
  hi: 'हिन्दी',
  zh: '汉语',
  fr: 'Français',
  mn: 'Монгол хэл',
  // ko: '한국어',
  // vi: 'Tiếng Việt',
  // ja: '日本語',
  // ar: 'عربى',
  // pt: 'Português (Brazil)',
}

export const langDefault = 'en'

export const appWalletGoogle =
  'https://play.google.com/store/apps/details?id=com.ultimawallet'
export const appWalletApple =
  'https://apps.apple.com/us/app/ultima-wallet/id1601950194'
export const appFarmGoogle =
  'https://play.google.com/store/apps/details?id=com.plcu.farm'
export const appFarmApple =
  'https://apps.apple.com/us/app/ultima-farm/id1602005130'

export const cdnDomain = 'https://ultimafarm.com/'

export const breakpoints = {
  phone: 0,
  tablet: 768,
  desktop: 1200,
}

export const localExchanges = [
  {
    code: 'MEXC',
    name: 'MEXC',
    logo: 'mexc.svg',
    url: 'https://www.mexc.com/exchange/PLCU_USDT',
  },
  {
    code: 'BKEX',
    name: 'BKEX',
    logo: 'bkex.svg',
    url: 'https://bkex.com/trade/PLCU_USDT',
  },
  {
    code: 'COINSBIT',
    name: 'Coinsbit',
    logo: 'coinsbit.svg',
    url: 'https://coinsbit.io/trade_classic/PLCU_USDT',
  },
  {
    code: 'ASCENDEX',
    name: 'Ascendex',
    logo: 'ascendex.svg',
    url: 'https://ascendex.com/cashtrade-spottrading/usdt/plcu',
  },
  {
    code: 'BITMART',
    name: 'BitMart',
    logo: 'bitmart.svg',
    url: 'https://www.bitmart.com/trade/en?symbol=PLCU_USDT&layout=basic',
  },
  {
    code: 'XT',
    name: 'xt.com',
    logo: 'xt.svg',
    url: 'https://www.xt.com/trade/plcu_usdt',
  },
  {
    code: 'COINW',
    name: 'CoinW',
    logo: 'coinw.svg',
    url: 'https://www.coinw.com/frontSpot/spottrade?symbol=945',
  },
  {
    code: 'BIGONE',
    name: 'BigOne',
    logo: 'big1.svg',
    url: 'https://big.one/en/trade/PLCU-USDT',
  },
  {
    code: 'DIGI_FINEX',
    name: 'Digifinex',
    logo: 'digifinex.svg',
    url: 'https://www.digifinex.com/en-ww/trade/USDT/PLCU',
  },
  {
    code: 'BICONOMY',
    name: 'Biconomy',
    logo: 'biconomy.svg',
    url: 'https://www.biconomy.com/exchange?coin=PLCU_USDT',
  },
]
